/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { useState, useMemo } from 'react';
import classNames from 'classnames';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { i as isEmpty_1 } from '../_chunks/dep-64a9d67c.js';
import { i as isString_1 } from '../_chunks/dep-6c5254c6.js';
import { SearchIcon } from 'tdesign-icons-react';
import { getLeafNodes } from './utils.js';
import useConfig from '../hooks/useConfig.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { Checkbox } from '../checkbox/index.js';
import { Input } from '../input/index.js';
import { Pagination } from '../pagination/index.js';
import { useLocaleReceiver } from '../locale/LocalReceiver.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-23d0a0bb.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-77e34309.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../_chunks/dep-e3db8410.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../common/Check.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-7dad86aa.js';
import '../_util/helper.js';
import '../_chunks/dep-2ffb6f37.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-08c1f545.js';
import '../hooks/useControlled.js';
import '../_util/noop.js';
import '../_chunks/dep-0e15088f.js';
import '../checkbox/defaultProps.js';
import '../checkbox/style/css.js';
import '../checkbox/type.js';
import '../input/Input.js';
import '../_util/useLayoutEffect.js';
import '../_util/dom.js';
import 'raf';
import '../_util/easing.js';
import '../input/InputGroup.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/style/css.js';
import '../input/type.js';
import '../pagination/Pagination.js';
import '../_chunks/dep-7b67cdbf.js';
import '../_chunks/dep-09050977.js';
import '../_chunks/dep-c8399d32.js';
import '../_chunks/dep-ca64038e.js';
import '../_chunks/dep-e73d1b75.js';
import '../select/index.js';
import '../select/base/Select.js';
import '../_chunks/dep-337b4140.js';
import '../select/util/helper.js';
import '../select/base/OptionGroup.js';
import '../select/defaultProps.js';
import '../select/base/Option.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../common/FakeArrow.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../select-input/index.js';
import '../select-input/SelectInput.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../hooks/usePrevious.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../select-input/useSingle.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-29cb89ad.js';
import '../select-input/useMultiple.js';
import '../tag-input/index.js';
import '../tag-input/TagInput.js';
import '../_util/useDragSorter.js';
import '../tag-input/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../tag/style/css.js';
import '../tag/type.js';
import '../tag-input/useHover.js';
import '../tag-input/defaultProps.js';
import '../tag-input/style/css.js';
import '../tag-input/type.js';
import '../select-input/useOverlayInnerStyle.js';
import '../select-input/defaultProps.js';
import '../select-input/style/css.js';
import '../select-input/type.js';
import '../select/base/PopupContent.js';
import '../select/hooks/usePanelVirtualScroll.js';
import '../hooks/useVirtualScroll.js';
import '../hooks/useResizeObserver.js';
import '../select/hooks/useOptions.js';
import '../select/style/css.js';
import '../select/type.js';
import '../input-number/index.js';
import '../input-number/InputNumber.js';
import '../button/index.js';
import '../button/Button.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../input-number/useInputNumber.js';
import '../_util/useCommonClassName.js';
import '../_common/js/input-number/number.js';
import '../_chunks/dep-a827ffec.js';
import '../_common/js/input-number/large-number.js';
import '../input-number/defaultProps.js';
import '../input-number/style/css.js';
import '../input-number/type.js';
import '../input-adornment/index.js';
import '../input-adornment/InputAdornment.js';
import '../input-adornment/style/css.js';
import '../input-adornment/type.js';
import '../pagination/hooks/useBoundaryJumper.js';
import '../pagination/hooks/usePrevNextJumper.js';
import '../pagination/hooks/usePageNumber.js';
import '../pagination/hooks/useTotal.js';
import '../pagination/validators.js';
import '../pagination/defaultProps.js';
import '../pagination/PaginationMini.js';
import '../pagination/style/css.js';
import '../pagination/type.js';

var TransferList = function TransferList(props) {
  var className = props.className,
    style = props.style,
    data = props.data,
    _props$search = props.search,
    search = _props$search === void 0 ? false : _props$search,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? [] : _props$checked,
    empty = props.empty,
    title = props.title,
    footer = props.footer,
    content = props.content,
    onCheckbox = props.onCheckbox,
    onSearch = props.onSearch,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    pagination = props.pagination,
    transferItem = props.transferItem,
    treeNode = props.tree,
    showCheckAll = props.showCheckAll;
  var notDisabledData = !treeNode ? data.filter(function (item) {
    return !item.disabled;
  }) : getLeafNodes(data).filter(function (item) {
    return !item.disabled;
  });
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var _useMemo = useMemo(function () {
      var activeLen = checked.length;
      var notLen = notDisabledData.length;
      return [activeLen && activeLen < notLen, activeLen && activeLen === notLen];
    }, [checked, notDisabledData]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    indeterminate = _useMemo2[0],
    allChecked = _useMemo2[1];
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useGlobalIcon = useGlobalIcon({
      SearchIcon: SearchIcon
    }),
    SearchIcon$1 = _useGlobalIcon.SearchIcon;
  var CLASSPREFIX = "".concat(classPrefix, "-transfer__list");
  var _useLocaleReceiver = useLocaleReceiver("transfer"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var handleCheckbox = function handleCheckbox(vals) {
    if (isFunction_1(onCheckbox)) onCheckbox(vals);
  };
  var handleAllCheckbox = function handleAllCheckbox(checked2) {
    if (isFunction_1(onCheckbox)) onCheckbox(checked2 ? notDisabledData.map(function (item) {
      return item.value;
    }) : []);
  };
  var HeaderCmp = function HeaderCmp() {
    var total = treeNode ? getLeafNodes(data).length : data.length;
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(CLASSPREFIX, "-header")
    }, /* @__PURE__ */React.createElement("div", null, showCheckAll ? /* @__PURE__ */React.createElement(Checkbox, {
      indeterminate: indeterminate,
      checked: allChecked,
      disabled: disabled,
      onChange: handleAllCheckbox
    }) : null, /* @__PURE__ */React.createElement("span", null, t(local.title, {
      checked: checked.length,
      total: total
    }))), /* @__PURE__ */React.createElement("span", null, title));
  };
  var SearchCmp = function SearchCmp() {
    return search ? /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-transfer__search-wrapper")
    }, /* @__PURE__ */React.createElement(Input, {
      placeholder: local.placeholder,
      suffixIcon: /* @__PURE__ */React.createElement(SearchIcon$1, null),
      onChange: onSearch
    })) : null;
  };
  var viewData = useMemo(function () {
    if (!isEmpty_1(pagination)) {
      var pageSize = pagination.pageSize || 10;
      var start = (currentPage - 1) * pageSize;
      return data.slice(start, start + pageSize);
    }
    return data;
  }, [currentPage, data, pagination]);
  var EmptyCmp = function EmptyCmp() {
    return isString_1(empty) ? /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-transfer__empty")
    }, /* @__PURE__ */React.createElement("span", null, empty || "\u6682\u65E0\u6570\u636E")) : empty;
  };
  var contentCmp = function contentCmp() {
    if (typeof treeNode === "function") {
      return treeNode({
        data: viewData,
        value: checked,
        onChange: handleCheckbox
      });
    }
    if (typeof content === "function") {
      return content({
        data: viewData
      });
    }
    return /* @__PURE__ */React.createElement(Checkbox.Group, {
      value: checked,
      onChange: handleCheckbox,
      disabled: disabled
    }, viewData.map(function (item, index) {
      return /* @__PURE__ */React.createElement(Checkbox, {
        key: item.value,
        value: item.value,
        disabled: item.disabled,
        className: "".concat(CLASSPREFIX, "-item")
      }, /* @__PURE__ */React.createElement("span", null, typeof transferItem === "function" ? transferItem({
        data: item,
        index: index,
        type: "source"
      }) : item.label));
    }));
  };
  var BodyCmp = function BodyCmp() {
    return /* @__PURE__ */React.createElement("div", {
      className: classNames("".concat(CLASSPREFIX, "-body"), _defineProperty({}, "".concat(CLASSPREFIX, "--with-search"), search))
    }, SearchCmp(), /* @__PURE__ */React.createElement("div", {
      className: "".concat(CLASSPREFIX, "-content narrow-scrollbar")
    }, viewData.length ? contentCmp() : EmptyCmp()));
  };
  var PaginationCmp = function PaginationCmp() {
    var handleCurrentPagination = function handleCurrentPagination(current) {
      setCurrentPage(current);
      if (isFunction_1(pagination.onPageChange)) {
        pagination.onPageChange(current);
      }
    };
    return pagination ? /* @__PURE__ */React.createElement("div", {
      className: "".concat(CLASSPREFIX, "-pagination")
    }, /* @__PURE__ */React.createElement(Pagination, {
      size: "small",
      theme: "simple",
      pageSizeOptions: [],
      total: data.length,
      totalContent: false,
      onCurrentChange: handleCurrentPagination,
      pageSize: pagination.pageSize
    })) : null;
  };
  var footerCmp = function footerCmp() {
    return !isEmpty_1(footer) ? /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-transfer__footer")
    }, footer) : null;
  };
  return /* @__PURE__ */React.createElement("div", {
    style: style,
    className: classNames(CLASSPREFIX, className)
  }, HeaderCmp(), BodyCmp(), PaginationCmp(), footerCmp());
};

export { TransferList as default };
//# sourceMappingURL=TransferList.js.map
